import { legalNoticeUrl } from './magnetLegalNotice.js';
const object = value => value && typeof value === 'object' && !Array.isArray(value);
const text = (value, max, label, required = false) => {
  if (typeof value !== 'string' || value.length > max || (required && !value.trim())) throw new Error(`${label}${required ? ' is required' : ''}; use ${max} characters or fewer.`);
  return value.trim();
};
export function hasMagnetConsent(value) { return value?.terms?.enabled === true || value?.email?.enabled === true; }
export function normalizeConsentDestination(value) {
  if (value == null) return null;
  if (!object(value) || value.provider !== 'hubspot' || value.business_unit_id !== '0'
      || ![value.account_id, value.subscription_id].every(id => typeof id === 'string' && /^[1-9]\d{0,14}$/.test(id))) throw new Error('Choose an available HubSpot email subscription.');
  return { provider: 'hubspot', account_id: value.account_id, subscription_id: value.subscription_id,
    business_unit_id: '0', name: text(value.name, 200, 'Subscription name', true) };
}
// Neither an opt-out flag nor a policy link is affirmative permission. Defaults
// deliberately contain no legal wording, acceptance, or marketing enrollment.
export function normalizeMagnetConsent(value) {
  if (!object(value) || value.version !== 1) throw new Error('Consent settings could not be read.');
  const result = { version: 1 };
  for (const key of ['terms', 'email']) {
    const part = value[key];
    if (!object(part) || typeof part.enabled !== 'boolean') throw new Error('Choose which permissions to ask for.');
    if (key === 'terms') {
      if (typeof part.required !== 'boolean') throw new Error('Choose whether agreement is required.');
      const url = part.url ? legalNoticeUrl(part.url) : '';
      if ((part.url && !url) || (part.enabled && !url)) throw new Error('Add a full link to your terms.');
      result.terms = { enabled: part.enabled, required: part.required,
        text: text(part.text, 400, 'Agreement wording', part.enabled), url,
        policy_version: text(part.policy_version, 80, 'Terms version', part.enabled),
        policy_text: text(part.policy_text, 20000, 'A copy of these terms', part.enabled) };
    } else {
      if (part.required === true) throw new Error('Email updates must be optional.');
      const url = part.privacy_url ? legalNoticeUrl(part.privacy_url) : '';
      if ((part.privacy_url && !url) || (part.enabled && !url)) throw new Error('Add a full link to your privacy policy.');
      result.email = { enabled: part.enabled,
        business: text(part.business, 120, 'Business name', part.enabled),
        purpose: text(part.purpose, 200, 'What subscribers will receive', part.enabled),
        text: text(part.text, 400, 'Email opt-in wording', part.enabled), privacy_url: url,
        ...(part.destination != null ? { destination: normalizeConsentDestination(part.destination) } : {}) };
    }
  }
  return result;
}
export function emptyMagnetConsent() {
  return { version: 1, terms: { enabled: false, required: false, text: '', url: '', policy_version: '', policy_text: '' },
    email: { enabled: false, business: '', purpose: '', text: '', privacy_url: '' } };
}
